import { selectUserDetails } from "../../redux/slices/auth"
import { useFetchBillingConfigQuery } from "../../redux/queries"
import { useAppSelector } from "./use-store"

export const useHasBillingFeature = (featureKey: string) => {
  const user = useAppSelector(selectUserDetails)
  const orgId = user?.org?.id ?? ""

  const { data, isLoading } = useFetchBillingConfigQuery(
    { org_id: orgId },
    { skip: !orgId }
  )

  const hasFeature = !!data?.[0]?.details?.features?.includes(featureKey)

  return { hasFeature, isLoading }
}
